module.exports = __webpack_public_path__ + "images/173cfaab6e13fad7a05636d52bfd36ba.svg";